
import { Button } from '@/components/ui/button';

interface NotificationActionsProps {
  isSaving: boolean;
  onSave: () => void;
  onTest: () => void;
}

const NotificationActions = ({ isSaving, onSave, onTest }: NotificationActionsProps) => {
  return (
    <div className="flex gap-3 pt-4">
      <Button 
        onClick={onSave} 
        disabled={isSaving}
        className="flex-1"
      >
        {isSaving ? 'Sauvegarde...' : 'Sauvegarder les paramètres'}
      </Button>
      <Button 
        variant="outline" 
        onClick={onTest}
        className="flex-1"
      >
        Tester le système
      </Button>
    </div>
  );
};

export default NotificationActions;
